export default function environmentReducer(state = {}) {
  const newState = state;
  return newState;
}
